import { render, staticRenderFns } from "./techprocessesAdd.vue?vue&type=template&id=392b3d46&scoped=true"
import script from "./techprocessesAdd.vue?vue&type=script&lang=js"
export * from "./techprocessesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392b3d46",
  null
  
)

export default component.exports